import { render, staticRenderFns } from "./AddFacture.vue?vue&type=template&id=349e9f46&"
import script from "./AddFacture.vue?vue&type=script&lang=js&"
export * from "./AddFacture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports